import useSWR from 'swr';
import { client } from "../contentful-config"

const fetcher = async ([url, reportId]) => {
    const entryItems = await client.getEntries({
        content_type: 'report',
        'fields.reportId': reportId,
    })
    const entries = entryItems.items.map((entry) => {
        const { fields } = entry
        const data = {
            reportName: fields.reportName,
            overview: fields.overview,
            reportId: fields.reportId,
            executiveSummary: fields.executiveSummary,
            competitiveLandscape: fields.competitiveLandscape,
            operatingConditions: fields.operatingConditions,
            keyStatistics: fields.keyStatistics,
            industryOutlook: fields.industryOutlook,
            keyTrends: fields.keyTrends,
            keySuccessFactors: fields.keySuccessFactors,
            majorCompanies: fields.majorCompanies,
            swotAnalysis: fields.swotAnalysis,
            pestleAnalysis: fields.pestleAnalysis,
            supplyChain: fields.supplyChain,
        }
        console.log(data)
        return data
    })
    const data = entries[0];
    return data
}

export default function useReport({ reportId }) {
    const { data, error, isLoading } = useSWR(['contentful', reportId], fetcher)

    return {
        data,
        error,
        isLoading,
    }
}